import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Footer.css";
import {
    FaFacebookF,
    FaTwitter,
    FaInstagram,
    FaLinkedinIn,
    FaYoutube,
    FaPhoneAlt,
    FaEnvelope,
    FaMapMarkerAlt,
    FaWhatsapp,
    FaApple,
    FaGooglePlay
} from "react-icons/fa";

const Footer = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleTestimonialClick = () => {
        if (location.pathname === "/") {
            // already on home
            document
                .getElementById("testimonials")
                ?.scrollIntoView({ behavior: "smooth" });
        } else {
            // go home and scroll
            navigate("/#testimonials");
        }
    };

    const currentYear = new Date().getFullYear();

    // Valid URLs for different sections
    const socialLinks = {
        facebook: "https://www.facebook.com/profile.php?id=61585309266874",
        twitter: "https://x.com/bgrealestate360",
        instagram: "https://www.instagram.com/bgrealstate360/#",
        linkedin: "https://www.linkedin.com/in/bg-realestate-a588493a1/",
        youtube: "https://www.youtube.com/channel/UCxYJ1sBCI22V-ynJ63XhHYg",
        whatsapp: "https://wa.me/918487916787"
    };

    const appLinks = {
        apple: "https://apps.apple.com/in/app/realestatepro/id123456789",
        google: "https://play.google.com/store/apps/details?id=com.realestatepro"
    };

    const companyLinks = {
        about: "/about",
        careers: "/careers",
        Gallery: "/Gallery",
        AllProperties: "/propertie",
        // testimonials: "/testimonials",
        sitemap: "/sitemap"
    };

    const propertyLinks = {
        residential: "/properties/residential",
        commercial: "/properties/commercial",
        industrial: "/properties/industrial",
        // agricultural: "/properties/agricultural",
        // luxury: "/properties/luxury",
        plots: "/properties/land"
    };

    // const cityLinks = {
    //     mumbai: "/properties/mumbai",
    //     delhi: "/properties/delhi",
    //     bangalore: "/properties/bangalore",
    //     pune: "/properties/pune",
    //     hyderabad: "/properties/hyderabad",
    //     chennai: "/properties/chennai"
    // };

    const legalLinks = {
        privacy: "PrivacyPolicy",
        terms: "/TermsConditions",
        // refund: "/legal/refund-policy",
        // disclaimer: "/legal/disclaimer",
        contact: "/ContactUs",
        // help: "/help"
    };

    const handleNewsletterSubmit = (e) => {
        e.preventDefault();
        // Handle newsletter subscription logic here
        console.log("Newsletter submitted");
    };

    return (
        <footer className="re360-footer">
            {/* Main Footer Section */}
            <div className="re360-footer-main">
                <div className="re360-footer-container">

                    {/* Company Info */}
                    <div className="re360-footer-column re360-footer-company-info">
                        <div className="re360-footer-logo">
                            <span className="re360-footer-logo-text">BG RealEstate<span className="re360-footer-logo-highlight">360</span></span>
                        </div>
                        {/* <p className="re360-footer-company-description">
                            India's leading real estate platform connecting buyers, sellers, and agents.
                            Trusted by over 50,000+ customers nationwide.
                        </p> */}

                        <div className="re360-footer-contact-info">
                            <div className="re360-footer-contact-item">
                                <FaPhoneAlt className="re360-footer-contact-icon" />
                                <div>
                                    <span className="re360-footer-contact-label">Call Us</span>
                                    <a href="tel:+9118001234567" className="re360-footer-contact-value">+91 8487916787</a>
                                </div>
                            </div>

                            <div className="re360-footer-contact-item">
                                <FaEnvelope className="re360-footer-contact-icon" />
                                <div>
                                    <span className="re360-footer-contact-label">Email Us</span>
                                    <a href="mailto:support@realestatepro.com" className="re360-footer-contact-value">info@realestate360.com</a>
                                </div>
                            </div>

                            <div className="re360-footer-contact-item">
                                <FaMapMarkerAlt className="re360-footer-contact-icon" />
                                <div>
                                    <span className="re360-footer-contact-label">Office Add: </span>
                                    <span className="re360-footer-contact-value">S/19, Crystal Plaza, Nr. Dominos pizza, GIDC, Kapodara Patiya, Ankleshwar.</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div className="re360-footer-column">
                        <h3 className="re360-footer-heading">Quick Links</h3>
                        <ul className="re360-footer-links">
                            <li><a href={companyLinks.about}>About Us</a></li>
                            {/* <li><a href={companyLinks.careers}>Careers</a></li>
                            <li><a href={companyLinks.Gallery}>Gallery</a></li> */}
                            <li><a href={companyLinks.AllProperties}>All Properties</a></li>
                            <li><a href="/#testimonials" onClick={handleTestimonialClick}>Testimonials</a></li>
                            {/* <li><a href={companyLinks.sitemap}>President Message</a></li> */}
                        </ul>
                    </div>

                    {/* Property Categories */}
                    <div className="re360-footer-column">
                        <h3 className="re360-footer-heading">Property Types</h3>
                        <ul className="re360-footer-links">
                            <li><a href={propertyLinks.residential}>Residential</a></li>
                            <li><a href={propertyLinks.commercial}>Commercial</a></li>
                            <li><a href={propertyLinks.industrial}>Industrial</a></li>
                            <li><a href={propertyLinks.plots}>Plot & Land</a></li>
                            {/* <li><a href={propertyLinks.luxury}>Luxury Homes</a></li>
                            <li><a href={propertyLinks.plots}>Plots & Land Properties</a></li> */}
                        </ul>
                    </div>

                    {/* Cities */}
                    {/* <div className="re360-footer-column">
                        <h3 className="re360-footer-heading">Popular Cities</h3>
                        <ul className="re360-footer-links">
                            <li><a href={cityLinks.mumbai}>Mumbai</a></li>
                            <li><a href={cityLinks.delhi}>Delhi</a></li>
                            <li><a href={cityLinks.bangalore}>Bangalore</a></li>
                            <li><a href={cityLinks.pune}>Pune</a></li>
                            <li><a href={cityLinks.hyderabad}>Hyderabad</a></li>
                            <li><a href={cityLinks.chennai}>Chennai</a></li>
                        </ul>
                    </div> */}

                    {/* Legal & Support */}
                    <div className="re360-footer-column">
                        <h3 className="re360-footer-heading">Legal & Support</h3>
                        <ul className="re360-footer-links">
                            <li><a href={legalLinks.privacy}>Privacy Policy</a></li>
                            <li><a href={legalLinks.terms}>Terms of Service</a></li>
                            {/* <li><a href={legalLinks.refund}>Refund Policy</a></li>
                            <li><a href={legalLinks.disclaimer}>Disclaimer</a></li> */}
                            <li><a href={legalLinks.contact}>Contact Us</a></li>
                            {/* <li><a href={legalLinks.help}>Help Center</a></li> */}
                        </ul>
                    </div>

                </div>
            </div>

            {/* Newsletter Section */}
            {/* <div className="re360-footer-newsletter-section">
                <div className="re360-footer-newsletter-container">
                    <div className="re360-footer-newsletter-content">
                        <h3 className="re360-footer-newsletter-title">Stay Updated</h3>
                        <p className="re360-footer-newsletter-subtitle">Subscribe to our newsletter for the latest property updates</p>

                        <form className="re360-footer-newsletter-form" onSubmit={handleNewsletterSubmit}>
                            <div className="re360-footer-input-group">
                                <input
                                    type="email"
                                    placeholder="Enter your email address"
                                    className="re360-footer-newsletter-input"
                                    required
                                />
                                <button type="submit" className="re360-footer-newsletter-btn">
                                    Subscribe
                                </button>
                            </div>
                            <div className="re360-footer-form-agreement">
                                <input type="checkbox" id="re360-footer-newsletter-agree" className="re360-footer-checkbox" required />
                                <label htmlFor="re360-footer-newsletter-agree">
                                    I agree to receive marketing communications from RealEstatePro
                                </label>
                            </div>
                        </form>
                    </div>
                </div>
            </div> */}

            {/* Mobile Apps */}
            {/* <div className="re360-footer-mobile-apps-section">
                <div className="re360-footer-mobile-apps-container">
                    <div className="re360-footer-apps-content">
                        <h3 className="re360-footer-apps-title">Download Our App</h3>
                        <p className="re360-footer-apps-subtitle">Find properties on the go with our mobile app</p>

                        <div className="re360-footer-app-buttons">
                            <a
                                href={appLinks.apple}
                                className="re360-footer-app-btn re360-footer-apple"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaApple className="re360-footer-app-icon" />
                                <div className="re360-footer-app-text">
                                    <span className="re360-footer-app-label">Download on the</span>
                                    <span className="re360-footer-app-name">App Store</span>
                                </div>
                            </a>

                            <a
                                href={appLinks.google}
                                className="re360-footer-app-btn re360-footer-google"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaGooglePlay className="re360-footer-app-icon" />
                                <div className="re360-footer-app-text">
                                    <span className="re360-footer-app-label">Get it on</span>
                                    <span className="re360-footer-app-name">Google Play</span>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div> */}

            {/* Bottom Footer */}
            <div className="re360-footer-bottom">
                <div className="re360-footer-bottom-container">

                    {/* Social Media */}
                    <div className="re360-footer-social-media">
                        <h4 className="re360-footer-social-title">Follow Us</h4>
                        <div className="re360-footer-social-icons">
                            <a
                                href={socialLinks.facebook}
                                className="re360-footer-social-icon re360-footer-facebook"
                                aria-label="Facebook"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaFacebookF />
                            </a>
                            <a
                                href={socialLinks.twitter}
                                className="re360-footer-social-icon re360-footer-twitter"
                                aria-label="Twitter"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaTwitter />
                            </a>
                            <a
                                href={socialLinks.instagram}
                                className="re360-footer-social-icon re360-footer-instagram"
                                aria-label="Instagram"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaInstagram />
                            </a>
                            <a
                                href={socialLinks.linkedin}
                                className="re360-footer-social-icon re360-footer-linkedin"
                                aria-label="LinkedIn"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaLinkedinIn />
                            </a>
                            <a
                                href={socialLinks.youtube}
                                className="re360-footer-social-icon re360-footer-youtube"
                                aria-label="YouTube"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaYoutube />
                            </a>
                            <a
                                href={socialLinks.whatsapp}
                                className="re360-footer-social-icon re360-footer-whatsapp"
                                aria-label="WhatsApp"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaWhatsapp />
                            </a>
                        </div>
                    </div>

                    {/* Copyright */}
                    <div className="re360-footer-copyright">
                        <p>
                            © {currentYear} BG RealEstate360. All rights reserved. |
                            <a href={legalLinks.privacy}> Privacy Policy</a> |
                            <a href={legalLinks.terms}> Terms of Service</a> 
                            {/* <a href={companyLinks.sitemap}> Sitemap</a> */}
                        </p>
                        <p className="re360-footer-disclaimer">
                            India's leading real estate platform connecting buyers, sellers, and agents.
                            Trusted by over 50,000+ customers nationwide.
                        </p>
                    </div>

                    {/* Payment Methods - These are not links, just icons */}
                    <div className="re360-footer-payment-methods">
                        <span className="re360-footer-payment-label">We Accept:</span>
                        <div className="re360-footer-payment-icons">
                            <span className="re360-footer-payment-icon re360-footer-visa" aria-label="Visa">Visa</span>
                            <span className="re360-footer-payment-icon re360-footer-mastercard" aria-label="MasterCard">MasterCard</span>
                            <span className="re360-footer-payment-icon re360-footer-upi" aria-label="UPI">UPI</span>
                            <span className="re360-footer-payment-icon re360-footer-netbanking" aria-label="Net Banking">NetBanking</span>
                            <span className="re360-footer-payment-icon re360-footer-wallet" aria-label="Digital Wallet">Wallet</span>
                        </div>
                    </div>

                </div>
            </div>

            {/* Fixed WhatsApp Button */}
            <a
                href={socialLinks.whatsapp}
                className="re360-footer-whatsapp-float"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Chat with us on WhatsApp"
            >
                <FaWhatsapp />
                <span className="re360-footer-whatsapp-text">Chat with us</span>
            </a>

        </footer>
    );
};

export default Footer;